export default __webpack_public_path__ + "static/media/u14.84a70ced.png";